import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { catchError, throwError } from 'rxjs'

import { ToastService } from '../components/toast/toast.service'
import { TOAST_STATE } from '../components/toast/types/toast.type'
import { AuthService } from '../services/auth.service'

export const httpErrorsInterceptor: HttpInterceptorFn = (req, next) => {
	const toastService = inject(ToastService)
	const authService = inject(AuthService)
	const router = inject(Router)
	const isLogin = req.url.includes('/auth/user_login')
	const isDemoLogin = req.url.includes('/auth/demo_login')

	return next(req).pipe(
		catchError((err) => {
			if (err instanceof HttpErrorResponse) {
				if (err.status >= 500 && err.status < 600 && isLogin) {
					router.navigateByUrl('/maintenance')
				} else if (err.error instanceof ProgressEvent && err.error.type === 'error') {
					toastService.showToast(TOAST_STATE.DANGER, 'Disconnected: Please refresh the page')
				} else if (err.status === 401 && err.error.error && typeof err.error.error === 'string' && err.error.error.includes('DETAIL: E0001')) {
					authService.clearUserData()
					router.navigateByUrl('/maintenance')
				} else if (err.status === 401 && !isLogin && !isDemoLogin) {
					authService.clearUserData()
					window.location.assign('/home')
				} else if (!isLogin && err.error.error && typeof err.error.error === 'string') {
					const formattedError = extractErrorMessage(err.error.error)
					toastService.showToast(TOAST_STATE.DANGER, formattedError ?? 'Contact administrator for further support.')
				}
			}

			return throwError(() => err)
		}),
	)
}

const extractErrorMessage = (text: string): string | null => {
	const regex = /ERROR: [^\n]+/
	const match = regex.exec(text)
	return match ? match[0] : null
}
